import type { ResolvedAssistantConfig } from "../types/tickets";

/** Whether the person can chat with Mochi right now, from the resolved
 * profile. "disabled": their organization switched chat off. "not_configured":
 * the server has no AI provider key. While the profile loads the answer is
 * "ok" so the composer never flashes a refusal. */
export type ChatAccess = "ok" | "disabled" | "not_configured";

export function chatAccessState(resolved?: Partial<ResolvedAssistantConfig> | null): ChatAccess {
  if (!resolved) return "ok";
  if (resolved.chat_enabled === false) return "disabled";
  if (resolved.ai_available === false) return "not_configured";
  return "ok";
}
